/* eslint-disable @nx/enforce-module-boundaries */
import { HStack, Stack } from '@mybridge/ui';
import { DiskDownloadProgress } from 'v4/components/disk/download-progress';
import { DiskFileInfoSection } from 'v4/components/disk/file-info-section';
import { TeamDiskUsagePanel } from 'v4/components/disk/team-disk/disk-usage';

export const TeamDiskBottomPanel = () => {
  return (
    <HStack borderTop="1px solid " borderColor="gray.100">
      <Stack p={4} w="30%" borderRight="1px solid" borderColor="gray.100">
        <TeamDiskUsagePanel />
      </Stack>
      <Stack p={4} flex={1} w="55%">
        <DiskFileInfoSection />
      </Stack>
      <Stack p={4} w="15%" alignItems="center">
        <DiskDownloadProgress />
      </Stack>
    </HStack>
  );
};
